import { IApplicationState } from '../../types/redux';

export function regionIdReducer(state: IApplicationState['regionId'] = 1): IApplicationState['regionId'] {
  return state;
}
